<template>
  <div>
    <div class="box" v-if="customer">
      <div class="header">
        <span class="header-label">{{ `Podopieczny > Dane osobowe` }}</span>
        <div class="header-actions">
          <custom-select
            v-if="prioritiesOptions && prioritiesOptions.length > 0"
            :default-value="selectedPriorityName"
            :options="prioritiesOptions"
            :graySelect="true"
            :large="true"
            :markSelected="true"
            :prePick="selectedPriorityId"
            style="min-width: 213px"
            @newPick="handleNewSelectedPriorityStatus"
          />

          <custom-select
            v-if="customerStatusesOptions && customerStatusesOptions.length > 0"
            :default-value="selectedCustomerStatusName"
            :options="customerStatusesOptions"
            :graySelect="true"
            :large="true"
            :markSelected="true"
            :prePick="selectedCustomerStatusId"
            style="width: 213px"
            @newPick="handleNewSelectedCustomerStatus"
          />

          <datepicker
            v-if="customer.dateOfResignation"
            :monday-first="true"
            :language="pl"
            v-model="dateOfResignation"
            :placeholder="'Wybierz datę'"
            :disabled-dates="disabledDates"
          ></datepicker>

          <span
            class="edit-data-redirect mr-4"
            @click="handleRedirectToEditUser"
            >Edytuj dane</span
          >
          <span class="edit-data-redirect" @click="openConfirmModalToRemoveUser"
            >Usuń</span
          >
        </div>
      </div>
      <div class="data">
        <p>
          <span class="data-label">Imię i nazwisko:</span>
          <span class="data-value"
            >{{ customer.firstName }} {{ customer.lastName }}</span
          >
        </p>
        <p>
          <span class="data-label">Adres:</span>
          <span class="data-value">{{ formattedAddress() }}</span>
        </p>

        <p>
          <span class="data-label">Wydział:</span>
          <span class="data-value">{{ customer.department.name }}</span>
        </p>

        <p>
          <span class="data-label">Odpłatność:</span>
          <span class="data-value">{{
            customer.payments && customer.payments[0]
              ? `${customer.payments[customer.payments.length - 1].amount} zł`
              : "Brak"
          }}</span>
        </p>

        <p>
          <span class="data-label">Zakres opieki:</span>
          <span class="data-value">{{
            customer.scopesOfCare.map((s) => s.name).join(", ")
          }}</span>
        </p>

        <p>
          <span class="data-label">Niestandardowy zakres:</span>
          <span class="data-value">{{ customer.note || "Brak" }}</span>
        </p>

        <p>
          <span class="data-label">Telefon:</span>
          <span class="data-value">{{ customer.phone || "Brak" }}</span>
        </p>

        <p>
          <span class="data-label">Kontakt:</span>
          <span class="data-value">{{ customer.contactNote || "Brak" }}</span>
        </p>

        <p>
          <span class="data-label">Telefon do pracownika socjalnego:</span>
          <span class="data-value">{{
            customer.socialWorkerPhone || "Brak"
          }}</span>
        </p>

        <p>
          <span class="data-label">Rejon:</span>
          <span class="data-value">{{ customer.region || "Brak" }}</span>
        </p>
      </div>
    </div>
    <div v-else class="box"></div>
  </div>
</template>

<script>
import CustomSelect from "../CustomSelect.vue";
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";
import moment from "moment";
export default {
  components: { CustomSelect, Datepicker },
  name: "CustomerPersonalData",
  props: ["customer"],
  emits: ["updated"],
  async mounted() {
    await this.$store.dispatch("getDodPriorities");
    await this.$store.dispatch("fetchCustomerStatuses");
    this.selectedPriorityId = this.customer.priority.id;
    this.selectedPriorityName = this.customer.priority.name;
    this.selectedCustomerStatusId = this.customer.status.id;
    this.selectedCustomerStatusName = this.customer.status.name;
    if (this.customer.dateOfResignation) {
      this.dateOfResignation = this.customer.dateOfResignation;
    }
    const startDate = moment("2022-01-01").toDate();
    const lastDayOfYear = moment().endOf("year").toDate();
    this.disabledDates = {
      to: startDate,
      from: lastDayOfYear,
    };
  },
  data() {
    return {
      selectedPriorityId: "",
      selectedPriorityName: "",
      selectedCustomerStatusName: "",
      selectedCustomerStatusId: "",
      pl,
      dateOfResignation: null,
      disabledDates: {},
    };
  },
  watch: {
    dateOfResignation: async function (val) {
      await this.updateCustomer(
        {
          dateOfResignation: moment(val)
            .set("hours", 12)
            .format("YYYY-MM-DDTHH:mm:ss"),
        },
        true
      );
    },

    customer: async function (val) {
      if (val.dateOfResignation) {
        this.dateOfResignation = val.dateOfResignation;
      }
    },
  },

  methods: {
    async openConfirmModalToRemoveUser() {
      if (confirm("Czy na pewno chcesz usunąć podopiecznego?")) {
        try {
          const response = await this.$store.dispatch(
            "removeCustomer",
            this.customer.id
          );
          if (response) {
            this.$notify({
              group: "success",
              text: "Pomyślnie usunięto podopiecznego",
            });
            this.$router.push({ name: "Customers" });
            await this.$store.dispatch("fetchStatusesCounters");
          }
        } catch (error) {
          const errorMessage = error.response?.data?.message;
          let polishMessage = "Wystąpił błąd podczas usuwania podopiecznego";

          if (errorMessage && errorMessage.includes("Forbidden delete, customer has orders")) {
            polishMessage = "Nie można usunąć klienta, który jest przypisany do zamówienia. Należy go zarchiwizować.";
          }

          this.$notify({
            group: "error",
            text: polishMessage,
          });
        }
      }
    },
    formattedAddress() {
      return `${this.customer.city}, ${this.customer.street}
          ${this.customer.streetNumber}
          ${
            this.customer.houseNumber ? `m. ${this.customer.houseNumber}` : ""
          }`;
    },

    async handleNewSelectedPriorityStatus(priorityId) {
      await this.updateCustomer({ priorityId });
    },
    async handleNewSelectedCustomerStatus(statusId) {
      await this.updateCustomer({ statusId }, true);
    },

    async updateCustomer(data, updateView) {
      await this.$store.dispatch("editDodCustomer", {
        customerId: this.customer.id,
        data,
      });

      await this.$store.dispatch("getCustomerMessages", {
        customerId: this.customer.id,
      });

      if (updateView) {
        this.$emit("updated");
      }
    },

    handleRedirectToEditUser() {
      this.$router.push({
        path: `/dod-add-customer-and-employee`,
        query: {
          customer: JSON.stringify(this.customer),
        },
      });
    },
  },

  computed: {
    priorities() {
      return this.$store.getters.getDodPriorities;
    },
    prioritiesOptions() {
      return this.priorities && this.priorities.data
        ? this.priorities.data.map((e) => ({
            value: e.id,
            name: e.name,
            shortName: e.name,
          }))
        : [];
    },
    customerStatuses() {
      return this.$store.getters.getCustomerStatuses;
    },
    customerStatusesOptions() {
      return this.customerStatuses
        ? this.customerStatuses.map((e) => ({
            value: e.id,
            name: e.name,
            shortName: e.name,
          }))
        : [];
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.header-label {
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #e2037e;
}
.box {
  padding: 1rem;
  border-radius: 8px;
  border: 0.5px solid rgba(9, 7, 65, 0.25);
  background: #fff;
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.25);
}
.data p {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.data-label {
  font-weight: 600;
  margin-right: 1rem;
}
.header-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
}
.edit-data-redirect {
  font-size: 14px;
  text-decoration: underline;
  height: fit-content;
  align-self: center;
  cursor: pointer;
}
</style>
